// Assets/stock-check.js – Versión limpia y funcional
(function () {
  const SECTION_SELECTOR = '#stock-query-section';
  const FORM_SELECTOR = '#stock-query-form';
  const EMAIL_SELECTOR = '#stock-email-input';
  const CONSENT_SELECTOR = '#stock-consent';
  const MSG_SELECTOR = '#stock-query-response';
  const BUTTON_SELECTOR = '#stock-query-button';
  const SKU_NODE_SELECTOR = '#product-sku-json';

  // ⚠️ Cambia a tu URL de Zapier (la del "Catch Hook")
  const WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/17234384/ur3rvzq/';

  function setMessage(html, ok = false) {
    const el = document.querySelector(MSG_SELECTOR);
    if (!el) return;
    el.innerHTML = html;
    el.style.display = 'block';
    el.style.color = ok ? 'var(--color-success, #1a7f37)' : 'var(--color-error, #b00020)';
  }

  function disableUI(disabled) {
    const btn = document.querySelector(BUTTON_SELECTOR);
    const email = document.querySelector(EMAIL_SELECTOR);
    if (btn) btn.disabled = disabled;
    if (email) email.disabled = disabled;
  }

  function currentProductContext() {
    const script = document.querySelector(SKU_NODE_SELECTOR);
    let data = {};
    try { data = JSON.parse(script?.textContent || '{}'); } catch (e) {}
    return {
      sku: data.sku || null,
      variant_id: data.variant_id || null,
      product_id: data.product_id || null,
      product_title: data.product_title || document.title,
      variant_title: data.variant_title || null,
      url: window.location.href,
    };
  }

  function attachSubmit() {
    const form = document.querySelector(FORM_SELECTOR);
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const email = (document.querySelector(EMAIL_SELECTOR)?.value || '').trim();
      const consent = document.querySelector(CONSENT_SELECTOR)?.checked;

      if (!email) { setMessage('Introduce un correo válido.'); return; }
      if (!consent) { setMessage('Debes aceptar el consentimiento.'); return; }

      const ctx = currentProductContext();
      if (!ctx.sku) { setMessage('No se pudo leer el SKU de la variante.'); return; }

      disableUI(true);
      setMessage('Enviando solicitud…', true);

      try {
        const payload = {
          email,
          sku: ctx.sku,
          variant_id: String(ctx.variant_id || ''),
          variant_title: ctx.variant_title || '',
          product_id: String(ctx.product_id || ''),
          product_title: ctx.product_title || '',
          page_url: ctx.url || window.location.href,
          ts: new Date().toISOString()
        };

        const formBody = new URLSearchParams(payload).toString();

        const res = await fetch(WEBHOOK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
          body: formBody,
          keepalive: true,
          mode: 'cors'
        });

        if (res.ok || res.type === 'opaque') {
          console.info('[stock-check] ✅ Enviado correctamente a Zapier', { status: res.status, type: res.type });
          setMessage(
            '✅ <strong>Solicitud enviada.</strong> Revisa tu correo en <strong>1 minuto</strong> para ver el <strong>stock actual</strong> del producto.',
            true
          );
          form.reset();
        } else {
          const txt = await res.text().catch(() => '');
          console.error('[stock-check] ❌ Error HTTP', res.status, txt);
          setMessage('No se pudo enviar la solicitud (HTTP ' + res.status + ').');
        }

      } catch (err) {
        console.error('[stock-check] ⚠️ Error de red o CORS:', err);
        setMessage('Error de conexión. Inténtalo más tarde.');
      } finally {
        disableUI(false);
      }
    });
  }

  // Actualiza el SKU si el usuario cambia de variante
  function listenVariantChange() {
    document.addEventListener('variant:change', (event) => {
      const v = event?.detail?.variant;
      if (!v) return;
      const node = document.querySelector(SKU_NODE_SELECTOR);
      if (!node) return;
      const data = JSON.parse(node.textContent || '{}');
      data.sku = v.sku || null;
      data.variant_id = v.id || null;
      data.variant_title = v.title || null;
      node.textContent = JSON.stringify(data);
    });
  }

  function init() {
    if (!document.querySelector(SECTION_SELECTOR)) return;
    attachSubmit();
    listenVariantChange();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
